export default "__VITE_ASSET__c182558e__"